import { useRoute, useRouter } from 'vue-router'
import type { FormInstance } from 'element-plus'
import headimg from 'assets/images/headimg.jpg'
import pictureImg from '/assets/images/picture.webp'
import directoryImg from '/assets/images/directory.webp'
import _ from 'lodash'
import dayjs from 'dayjs'
import { getCodeByName, getNameByCode } from '~/components/Hotel/city-data'
import qs from 'qs'
import { batchProcessRequests } from '~/utils/fetchUtils'
import {
  fetchApplyBooth,
  fetchExhibitionBoothInfoById,
  fetchExhibitionById,
  fetchExhibitionFollow,
  fetchExhibitionGroup,
  fetchExhibitionList,
  fetchExhibitionScoreById,
  fetchVideoPlayAuth
} from '~/api/exhibition'
import { fetchTicketById } from '~/api/ticket'
import { fetchNewsHomePageList, getNewsByExhibitionId, fetchNewsApiGetNews } from '~/api/newsApi'
import { fetchSpecialTopicByResourceId } from '~/api/specialTopic'
import { fetchExhibitionFollowedUsers } from '~/api/followeApi'
import { fetchInnerChainPage } from '~/api/innerChain'
import { fetchHRStaffServices } from '~/api/hr'
import { clientFetchMessagesById } from '~/api/message'
import { clientFetchPageBanner } from '~/api/bannerApi'
import { fetchExhibitionResource } from '~/api/exhibitionResource'
import { clientFetchNewPeriodical, fetchPeriodicalById } from '~/api/periodicalApi'
import { fetchReverseGeocoding } from '~/api/baidu'
import { fetchHotelList } from '~/api/aliTripApi'
import JuZhanMini from 'assets/images/juzhan-mini.jpg'
import { fetchOrderStatus } from '~/api/pay'
import { checkDevice, getWhiteScreenTime, getXOssWebpSize } from '~/utils/common'
import { fetchCompanyByKeyword } from '~/api/companyApi'
import { exhibitorCheckUser, fetchExhibitorList } from '~/api/exhibitorApi'
import { fetchCreateWXACode } from '~/api/wx'
import { ELocale } from '~/types/enums'

export const useFairDetail = async (_lang: ELocale) => {
  onMounted(() => {
    console.log('onMounted => ???')
    getWhiteScreenTime()
    getAreaExh()
    getRate()
    checkFairLanguage()
    getOrderMessage()
    getBanner()
    getNewPeriodical()
    if (checkDevice() === 'h5') {
      let url = `https://m.jufair.com/exhibition/${route.params.id}.html`
      // window.location.replace(url)
    }
    getService()
    if (import.meta.client) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = 'https://g.alicdn.com/de/prismplayer/2.9.3/skins/default/aliplayer-min.css'
      link.as = 'style'
      document.head.appendChild(link)

      const videoEl: any = document.getElementById('video')
      videoEl?.addEventListener('ended', () => {
        // 在视频播放结束时执行的其他操作
        videoEl.style.display = 'none'
      })
      // 解密展会介绍
      detail.value.introduction = decryptAndReplace(
        detail.value.introduction,
        detail.value.informationSecret
      )

      const first: any = document.getElementById('pane-first')
      const title: any = document.getElementById('title')
      getPlayAuth()
      if (routeHash.value !== '#view') {
        if (first && title) {
          title.style.height = first.offsetHeight + 'px'
        }
        window.addEventListener('scroll', handleScrollDebounce)
      }

      if (routeHash.value == '#view') {
        getResource()
      }
    }

    // 计算订单消息位置
    try {
      // const parentEl = this.$refs.exh_detail_right;
      // const dateEl = this.$refs.date;
      const parentRect = exhDetailRightRef.value?.getBoundingClientRect() || {}
      const dateRect = dateRef.value?.getBoundingClientRect() || {}
      // console.log(2606, dateRect.top, parentRect.top);
      datePosition.value = {
        // top: dateRect.top - parentRect.top,
        top: 20, // dateRect.top - parentRect.top - 55, //
        left: dateRect.left - parentRect.left,
        bottom: dateRect.bottom - parentRect.top,
        right: dateRect.right - parentRect.left
      }
    } catch (e) {
      showMessage.value = false
    }
  })

  const route = useRoute()
  const router = useRouter()
  const runtime = useRuntimeConfig()
  const id = route.params.id
  const { lang,$t } = useLang(_lang)

  const { t } = useI18n()
  
  const { $windowOpen } = useNuxtApp()
  const globalStore = useGlobalStore()
  const userStore = useUserStore()
  const exhibitionStore = useExhibitionStore()
  const sessionStore = useSessionStore()
  const tokenCookie = useCookie('access_token')

  const loginModal = computed(() => globalStore.loginModal)
  const ruleRef = ref<FormInstance | null>(null)
  const payDespositRef = ref<any>()
  const orderInfoRef = ref<any>()
  const evaluationRef = ref<any>()
  const serverStepRef = ref<any>()
  const exhDetailRightRef = ref<any>()
  const dateRef = ref<any>()
  const playauth = ref<string>('')
  const player = ref<any>(null)
  const detail = ref<Record<string, any>>({})
  const industry = ref<any[]>([])
  const industryId = ref<any[]>([])
  const industryName = ref<any[]>([])
  const isFocus = ref<boolean>(false) // 是否关注
  const remind = ref<boolean>(false) // 是否提醒

  const sameFair = ref<Record<string, any>>({}) // 同期展会
  const logoFair = ref<Record<string, any>[]>([]) // 系列展会
  const booth = ref<Record<string, any>>({}) // 展会价格
  const ticketPrice = ref<Record<string, any>>({}) // 门票价格
  const exhibitorData = ref<Record<string, any>>({}) // 展商名录
  const periodicalList = ref<Record<string, any>>({}) // 展商名录价格

  const industryFair = ref<Record<string, any>[]>([]) // 行业展会
  const fairNews = ref<Record<string, any>[]>([]) // 展会资讯
  const news = ref<Record<string, any>[]>([]) // 行业资讯
  const tag = ref<Record<string, any>[]>([])
  const resourceList = ref([])
  const follow = ref<Record<string, any>>({})
  const banner = ref<any[]>([])
  const newNews = ref([])
  const newFair = ref([])
  const innerChainActive = ref<number>(0)
  const innerChainAreaList = ref<any[]>([])
  const innerChainIndustryList = ref<any[]>([])
  const innerChainExhList = ref<any[]>([])
  const boothServiceList = ref<any[]>([])
  const ticketServiceList = ref<any[]>([])
  const serviceListAll = ref<any>({})
  const messageList = ref<any[]>([])
  const areaExhList = ref<any[]>([])
  const newPeriodical = ref<Record<string, any>>({})
  const isSdkReady = ref(false)
  const videoVisible = ref(false)
  const dialogShow = ref(false)
  const mapDialogShow = ref(false)
  const reptileShow = ref(false)
  const showPoster = ref(false)
  const showSubsidy = ref(false)
  const applyTitle = ref('')
  const applyVisible = ref(false)
  const dialogTitle = ref('')
  const dialogImg = ref('')
  const messageTitle = ref('')
  const isLoading = ref(false)
  const showView = ref(route.hash === '#view')
  const showMore = ref(false)
  const showMessage = ref(false)
  const routeHash = ref(route.hash)
  const current = ref('')
  const display = ref('')
  const displayCode = ref('')
  const hotelList = ref<any[]>([])
  const showTitle = ref<boolean>(false)
  const activeName = ref<string>('first')
  const stateIsLogin = ref(false)
  const rateData = ref<Record<string, any>>({
    scaleScore: 0,
    specialityScore: 0,
    evaluateScore: 0,
    audienceScore: 0,
    marketScore: 0
  })
  const rateValue = ref<number>(0)
  const ruleForm = ref({
    companyName: '',
    linkman: '',
    linkmanPhoneNumber: '',
    email: '',
    remark: ''
  })
  const rules = ref({})
  const datePosition = ref<Record<string, any>>({})
  const sameSwiperOption = ref({
    slidesPerView: 3.2,
    spaceBetween: 10,
    autoplay: 3000, // l轮播间隔时间
    loop: false //
  })
  const attribution = ref()
  const center = ref()
  const downloadList = [
    // {
    //   text: t('exhibitionDetail.exhibitionInvitationLetter'),
    //   url: ZZH
    // },
    {
      text: t('exhibitionDetail.boothMap'),
      url: pictureImg
    },
    {
      text: t('personal.right.electronic_journal'),
      url: directoryImg
    }
    // {
    //   text: t('exhibitionDetail.buyerData'),
    //   url: MJSJ
    // }
  ]

  let resetNum = 0

  const photos = computed(() => {
    try {
      const newArr: any[] = []
      if (detail.value.photos) {
        detail.value.photos.slice(1).map((item: { resourceUrl: any }) => {
          let str = ''

          if (!item.resourceUrl.includes('!swebp') && !item.resourceUrl.includes('x-oss-process')) {
            // 如果不包含，则在URL末尾添加!swebp后缀
            // item.resourceUrl += '!swebp' //
            // str = item.resourceUrl + getXOssWebpSize({ w: 800, h: 560, watermark: false })
            item.resourceUrl =
              item.resourceUrl + getXOssWebpSize({ w: 800, h: 560, watermark: true })
          }
          newArr.push(item.resourceUrl)
          // newArr.push(str)
        })
      }
      // console.log('258--', newArr)
      return newArr
    } catch (error) {
      return detail.value.pic
    }
  })
  const qrcode = computed(() => {
    const { id } = route.params

    const openId = globalStore.openId
    const tel = globalStore.user?.userName
    return `${MINI_HOST}?exhibitionId=${id}&openId=${openId}&tel=${tel}`
  })
  const industryList = computed(() => {
    if (detail.value.industry) {
      try {
        return detail.value.industry?.split(',')
      } catch (error) {
        return []
      }
    }
    return []
  })
  const tips = computed(() => {
    try {
      const { tips } = ticketPrice.value
      return JSON.parse(tips).slice(0, 2)
    } catch (error) {
      return []
    }
  })
  const hasPhoneOrEmail = computed(() => {
    const val: string[] = []
    const { containPhoneEmail = [] } = newPeriodical.value
    if (containPhoneEmail.includes('0')) {
      val.push('电话')
    }
    if (containPhoneEmail.includes('1')) {
      val.push('邮箱')
    }
    if (containPhoneEmail.includes('2')) {
      val.push('官网')
    }
    return val.length > 0 ? `含${val.join('、')}` : ''
  })
  const pavilionPicture = computed(() => {
    const val = _.get(detail, 'value.pavilionInfo.picture', '')
    try {
      // return val.split(';')
      let list = val.split(';')
      const newArr: any[] = []
      if (list.length > 0) {
        list.map((item: any) => {
          if (!item.includes('!swebp')) {
            // 如果不包含，则在URL末尾添加!swebp后缀
            // item += '!swebp'
            item += getXOssWebpSize({ w: 390, h: 295, watermark: false })
          }
          newArr.push(item)
        })
      }

      return newArr
    } catch (e) {
      return [val]
    }
  })
  const optionName = computed(() => {
    let pavilionName = _.get(detail, 'value.pavilionInfo.pavilionName', '')
    pavilionName = pavilionName?.replace(/（/g, '(')?.replace(/）/g, ')')

    return pavilionName
  })
  const hotelQuery = computed(() => {
    const query = {
      adult: 1,
      checkin: dayjs().format('YYYY-MM-DD'),
      checkout: dayjs().add(3, 'days').format('YYYY-MM-DD'),
      children: 0,
      display: detail.value.area,
      cityCode: getNameByCode(detail.value.area),
      crn: 1,
      optionName: optionName.value,
      starlist: '4,5'
    }

    return qs.stringify(query)
  })
  const isLogin = computed(() => globalStore.isLogin)

  let apiErrorList: any = []

  const { data } = await useAsyncData('pageData', async () => {
    return await batchProcessRequests(
      [
        () => fetchExhibitionById({ id }),
        () =>
          fetchExhibitionList({
            locale: lang,
            selectTimeType: 1,
            exhibitionId: id,
            exhibitionType: 'CURRENT', // 同期展会
            pageNum: 1,
            pageSize: 30
          }),
        () =>
          fetchExhibitionList({
            locale: lang,
            selectTimeType: 1,
            exhibitionId: id,
            exhibitionType: 'SERIES', // 系列展会
            pageNum: 1,
            pageSize: 30
          }),
        () => fetchExhibitionBoothInfoById({ id }),
        () => fetchTicketById({ id }),
        () => fetchPeriodicalById({ id }),
        () => fetchExhibitionGroup({ id })
      ],
      { parallel: true }
    )
  })

  const [detailRes, sameFairRes, logoFairRes, boothRes, ticketRes, periodicalRes, sessionsRes] =
    data.value || []
  const sessionsFair = ref([])
  if (_.get<any, string>(sessionsRes, 'code') == ResponseCode.SUCCESS) {
    sessionsRes.data.groupList?.forEach((item: any) => {
      const startTime = item.startTime?.slice(0, 10).replace(/-/g, '.')
      const endTime = item.endTime?.slice(5, 10).replace(/-/g, '.')
      item.lunchTime = startTime + '-' + endTime
    })
    sessionsFair.value = sessionsRes.data?.groupList?.filter((item: any) => !!item.exhibitionName)
    if (sessionsFair.value.length > 4) {
      sessionsFair.value = sessionsFair.value.splice(0, 4)
    }
  }

  if (_.get<any, string>(detailRes, 'code') === ResponseCode.BLACK_LOGIN) {
    throw createError({
      statusCode: 504,
      statusMessage: '先登录！',
      message: route.fullPath
    })
  }

  if (_.get<any, string>(detailRes, 'code') !== ResponseCode.SUCCESS) {
    apiErrorList.push({ code: detailRes?.code, message: detailRes?.message })
    handleNodeServerError(JSON.stringify(apiErrorList))
  }

  if (
    _.get<any, string>(detailRes, 'code') === ResponseCode.SUCCESS &&
    _.get<any, string>(detailRes, 'data')
  ) {
    try {
      if (detailRes?.data.boothInfo) {
        detailRes.data.boothInfo = JSON.parse(detailRes?.data.boothInfo)
      } else {
        detail.value.boothInfo = []
      }
    } catch (e) {}
    // console.log('400-400', detailRes?.data)

    detail.value = detailRes?.data || {}
    detail.value.informationSecret = detailRes?.informationSecret
    detail.value.introduction = detail.value.introduction.replace(
      /(<img[^>]+src="[^"]+)(["'])([^>]*>)/gi,
      function (match: any, p1: any, p2: any, p3: any) {
        return p1 + '!swebp' + p2 + p3
      }
    )

    detail.value.boothPrice1 = 0
    detail.value.boothPrice2 = 0
    if (detail.value.boothInfo && detail.value.boothInfo.length > 0) {
      detail.value.boothInfo.forEach((item: any) => {
        if (item.priceType === '标准展位') {
          detail.value.boothPrice1 = item.price
        }
        if (item.priceType === '光地展位') {
          detail.value.boothPrice2 = item.price
        }
      })
    }
    detail.value.exhibitionNotesList = []
    if (detail.value.exhibitionNotes) {
      detail.value.exhibitionNotesList = detail.value.exhibitionNotes.split(',')
    }
    // online 1:上架 2:未上架
    // console.log('410--')
    // if (
    //   (+id !== 4 && !_.isNil(detail.value.online) && detail.value.online !== 1) ||
    //   _.isNil(detailRes?.data)
    // ) {
    //   throw createError({
    //     statusCode: 404,
    //     statusMessage: '已下架-',
    //     message: '已下架' // route.fullPath
    //   })
    // }
    industryId.value = [
      detail.value.industry1,
      detail.value.industry2,
      detail.value.industry3
    ].filter(id => !!id)
    industryName.value = detail.value.industry?.split(',') || []
    industryName.value.forEach((name, index) => {
      industry.value.push({
        id: industryId.value[index],
        name
      })
    })
    isFocus.value = detailRes.data?.follow // 1: 已关注 0: 未关注
    remind.value = detailRes.data.follow // 1: 提醒 0: 未提醒
  } else {
    throw createError({
      statusCode: 404,
      statusMessage: '展会不存在！',
      message: route.fullPath
    })
  }

  // 多届展会
  sessionStore.fetchSessions(+id)

  // 同期展会
  if (_.get<any, string>(sameFairRes, 'code') === ResponseCode.SUCCESS) {
    sameFair.value = sameFairRes?.data
  }

  // 系列展会
  if (_.get<any, string>(logoFairRes, 'code') === ResponseCode.SUCCESS) {
    logoFair.value = logoFairRes?.data
  }

  // 展会价格
  if (_.get<any, string>(boothRes, 'code') === ResponseCode.SUCCESS) {
    booth.value = boothRes?.data
  }

  // 门票价格
  if (_.get<any, string>(ticketRes, 'code') === ResponseCode.SUCCESS) {
    ticketPrice.value = ticketRes?.data
  }

  // 展商名录价格
  if (_.get<any, string>(periodicalRes, 'code') === ResponseCode.SUCCESS) {
    try {
      // 将不可预览的过滤掉
      const filteredData = periodicalRes.data.filter((item: any) => item.jump)
      if (filteredData.length > 0) {
        // 可预览的获取到年份最大的
        periodicalList.value = filteredData.reduce((max: any, current: any) =>
          current.year > max.year ? current : max
        )
      } else {
        if (periodicalRes.data && periodicalRes.data.length) {
          // 如果都是不可预览，则显示年份最大的
          periodicalList.value = periodicalRes.data.reduce((max: any, current: any) =>
            current.year > max.year ? current : max
          )
        }
      }
      if (periodicalList.value.id) {
        const exhibitorRes = await fetchExhibitorList({
          exhibitionId: id,
          periodicalId: periodicalList.value.id,
          pageNum: 1,
          pageSize: 5
        })
        if (exhibitorRes.code === ResponseCode.SUCCESS) {
          exhibitorData.value = exhibitorRes.data || {}
        }
      }
    } catch (e) {
      console.error('获取最新年份期刊', e)
    }
  }
  const { data: otherRes } = await useAsyncData('otherRes', async () => {
    return await batchProcessRequests([
      () =>
        fetchExhibitionList({
          locale: lang,
          selectTimeType: 1,
          industryId: _.get(industry, '[0].id', null), // 行业展会
          regionType: detail.value.regionType,
          pageNum: 1,
          pageSize: 8
        }),

      () =>
        fetchSpecialTopicByResourceId({
          type: 0,
          resourceId: id
        }),
      () =>
        fetchExhibitionFollowedUsers({
          exhibitionId: id,
          pageNum: 1,
          pageSize: 12
        }),
      () =>
        fetchNewsApiGetNews({
          locale: lang,
          exhibitionId: id,
          industryId: _.get(industry, '[0].id', null), // 推荐资讯
          newsType: 1
          // pageNum: 1,
          // pageSize: 13
        }) // 展会资讯、行业资讯
    ])
  })

  const [industryFairRes, tagRes, followRes, newsByFairIdRes] = otherRes.value || []

  // 行业展会
  if (_.get<any, string>(industryFairRes, 'code') === ResponseCode.SUCCESS) {
    industryFair.value = industryFairRes?.data
  }
  // 展会资讯、行业资讯
  if (_.get<any, string>(newsByFairIdRes, 'code') === ResponseCode.SUCCESS) {
    if (Array.isArray(newsByFairIdRes?.data.exhibitionNews)) {
      fairNews.value = newsByFairIdRes?.data.exhibitionNews.map((n: any) => ({
        newsId: n.id,
        viewUrl: n.viewUrl,
        newsName: n.title,
        views: n.viewCount,
        logo: n.coverImg,
        publishTime: n.publishTime,
        description: n.description
      }))
    }

    if (Array.isArray(newsByFairIdRes?.data.industryNews)) {
      // 行业资讯
      news.value = newsByFairIdRes?.data.industryNews.map((item: Record<string, any>) => ({
        newsId: item.newsId,
        viewUrl: item.viewUrl,
        newsName: item.newsName,
        views: item.views,
        logo: item.logo,
        publishTime: item.publishTime,
        description: item.description
      }))
    }
  }

  if (_.get<any, string>(tagRes, 'code') === ResponseCode.SUCCESS) {
    tag.value = tagRes?.data
  }

  if (_.get<any, string>(followRes, 'code') === ResponseCode.SUCCESS) {
    follow.value.data = followRes?.data?.records || []
    follow.value.total = followRes?.data?.total || 0
  }

  // 内链
  let paramsIndustry: any[] = []
  if (!isNaN(detail.value.firstIndustryId)) paramsIndustry.push(detail.value.firstIndustryId)
  if (detail.value.industry1) paramsIndustry.push(detail.value.industry1)
  if (detail.value.industry2) paramsIndustry.push(detail.value.industry2)
  if (detail.value.industry3) paramsIndustry.push(detail.value.industry3)
  const { data: innerChainAllRes } = await useAsyncData('innerChainAllRes', async () => {
    return await batchProcessRequests(
      [
        () =>
          fetchInnerChainPage({
            category: '热门地区',
            pageSize: 16
            // locale: detail.locale,
          }),
        () =>
          fetchInnerChainPage({
            category: '热门行业',
            industryIdList: paramsIndustry,
            pageSize: 16
            // locale: detail.locale,
          }),
        () =>
          fetchInnerChainPage({
            category: '热门展会',
            industryIdList: paramsIndustry,
            pageSize: 16
            // locale: detail.locale,
          })
      ],
      { parallel: true }
    )
  })

  const [innerChainAreaRes, innerChainIndustryRes, innerChainExhRes] = innerChainAllRes.value || []

  if (_.get<any, string>(innerChainAreaRes, 'code') === ResponseCode.SUCCESS) {
    innerChainAreaList.value = innerChainAreaRes?.data.records
  }
  if (_.get<any, string>(innerChainIndustryRes, 'code') === ResponseCode.SUCCESS) {
    innerChainIndustryList.value = innerChainIndustryRes?.data.records
    let len = innerChainIndustryList.value.length
    if (len < 16) {
      const { data: ctxIndustry } = await useAsyncData('ctxIndustry', async () => {
        return await batchProcessRequests(
          [
            () =>
              fetchInnerChainPage({
                category: '热门行业',
                pageSize: 16 - len
                // locale: detail.locale,
              })
          ],
          { parallel: true }
        )
      })

      const [innerChainArea2Res] = ctxIndustry.value || []
      if (_.get<any, string>(innerChainArea2Res, 'code') === ResponseCode.SUCCESS) {
        innerChainIndustryList.value = innerChainIndustryList.value.concat(
          innerChainArea2Res?.data.records
        )
      }
    }
  }
  if (_.get<any, string>(innerChainExhRes, 'code') === ResponseCode.SUCCESS) {
    innerChainExhList.value = innerChainExhRes?.data.records
    let len = innerChainExhList.value.length
    if (len < 16) {
      const { data: ctxIndustry } = await useAsyncData('ctxIndustry2', async () => {
        return await batchProcessRequests(
          [
            () =>
              fetchInnerChainPage({
                category: '热门展会',
                pageSize: 16 - len
                // locale: detail.locale,
              })
          ],
          { parallel: true }
        )
      })

      const [innerChainExh2Res] = ctxIndustry.value || []
      if (_.get<any, string>(innerChainExh2Res, 'code') === ResponseCode.SUCCESS) {
        innerChainExhList.value = innerChainExhList.value.concat(innerChainExh2Res?.data.records)
      }
    }
  }

  attribution.value = `&copy; <span>${
    _.get(detail, 'value.pavilionInfo.pavilionName', null) ||
    _.get(detail, 'value.pavilionInfo.pavilionEnglishName', null)
  }</span>`
  center.value = [
    _.get(detail, 'value.pavilionInfo.latitude', 0),
    _.get(detail, 'value.pavilionInfo.longitude', 0)
  ]

  // filters
  const dateFormat2 = (date: string) => {
    return dayjs(new Date(date)).format('YYYY年MM月DD日')
  }

  const newDateFormat = (data: Record<string, any>) => {
    if (data.startTime && data.endTime) {
      const startTime = dayjs(data.startTime).format('YYYY.MM.DD')
      const endTime = dayjs(data.endTime).format('MM.DD')
      return `${startTime}-${endTime}`
    } else {
      return '时间待定'
    }
  }

  const industryFilter = (data: string): string => {
    if (!data) {
      return ''
    }
    let str = t('common.expo')
    try {
      return data.split(',')[0] + str
    } catch (error) {
      if (import.meta.client && 'fundebug' in window) {
        ;(window as any).fundebug.notifyError(`${error},useFairDetail-737`)
      }
      return data + str
    }
  }

  const logo = (value: string): string => {
    let parse: any = value
    try {
      parse = JSON.parse(value)[0].replace('http://', 'https://').replace(bucketHost, bucketCdnHost)
    } catch (error) {
      parse = value
      //   console.error(error);
    }
    // return parse + '!logo'
    return parse + getXOssWebpSize({ w: 564, h: 334 })
  }

  // 用于将字符串中的数字进行转换
  const formatNumber = (value: string): string => {
    // 如果输入值为空，则返回空字符串
    if (!value) return ''
    if (!lang || lang == 'cn') {
      // 使用正则表达式匹配输入字符串中的数字和单位
      const match = value.match(/^(\d+)([^\d]+)$/)

      // 如果没有匹配到数字，则返回原始值
      if (!value) return value

      // 获取匹配到的数字和单位
      const number = value // match[1];

      // 初始化结果字符串
      let result = ''

      // 将字符串数字转为数值进行比较
      const numericValue = parseInt(number, 10)

      // 数字转换逻辑
      if (numericValue >= 10000) {
        result = (numericValue / 10000).toFixed(1) + '万'
      } else if (numericValue >= 1000) {
        result = (numericValue / 1000).toFixed(1) + '千'
      } else {
        result = number
      }
      // 拼接转换后的数字和原有的单位，并返回结果
      return result
    } else {
      return value
    }
  }

  // methods
  const handleScroll = () => {
    const menuDomList = document.querySelectorAll('a[data-name]')
    const { scrollTop } = document.documentElement

    const res = Array.from(menuDomList).reduce((current, next) => {
      const nextTop = getDisTop(next)
      const top = nextTop - scrollTop
      if (top > 20) {
        return current
      } else {
        return next
      }
    }, menuDomList[0])

    const name = res.getAttribute('data-name') as string
    setCurrent(name)
  }

  const handleScrollDebounce = _.debounce(handleScroll, 300)

  // 获取当前国家同行业展会
  const getAreaExh = async () => {
    const res = await fetchExhibitionList({
      locale: lang,
      industryId: detail.value.firstIndustryId,
      areaType: detail.value.regionType,
      area: detail.value.pavilionInfo?.areaId,
      pageNum: 1,
      pageSize: 10
    })

    if (res?.code === ResponseCode.SUCCESS) {
      const list = res?.data.records
      areaExhList.value = list.splice(1, 9)
    }
  }
  // 获取评分
  const getRate = async () => {
    const res = await fetchExhibitionScoreById({
      exhibitionId: detail.value.exhibitionId
    })
    // console.log('rate', res);
    if (res?.code === ResponseCode.SUCCESS) {
      let count: number = 0
      if (!res?.data) return false
      for (let i in rateData.value) {
        rateData.value[i] = res?.data[i]
        count += res?.data[i]
      }
      rateValue.value = Number((count / 5).toFixed(1))

      exhibitionStore.setRateData(rateData.value)
      exhibitionStore.setRateValue(rateValue.value)
    }
  }
  // 获取客服
  const getService = async () => {
    const res = await fetchHRStaffServices({
      exhibitionId: detail.value.exhibitionId,
      industry: detail.value.industry1,
      skillCodes: ['exOnlineSale', 'ticketOnlineSale']
    })
    if (res?.code === ResponseCode.SUCCESS) {
      let list = res?.data
      list.map((item: any) => {
        item.avatar = `${item.avatar}?x-oss-process=image/auto-orient,1/interlace,1/resize,m_fill,w_70,h_70/sharpen,100`
      })
      let saleList: any = list.filter((i: any) =>
        i.skillList.some((x: any) => x.skillCode == 'exOnlineSale')
      )
      boothServiceList.value = saleList || []

      // 门票客服
      let newList: any = list.filter((i: any) =>
        i.skillList.some((x: any) => x.skillCode == 'ticketOnlineSale')
      )
      // console.log('门票客服', newList);
      ticketServiceList.value = newList || []
      serviceListAll.value = {
        ticketServiceList: ticketServiceList.value,
        boothServiceList: boothServiceList.value
      }
    }
  }
  const getOrderMessage = async () => {
    const id = route.params.id
    if (!id) return
    const res = await clientFetchMessagesById({ id })
    if (res?.code === ResponseCode.SUCCESS) {
      messageList.value = res?.data || []
    }
  }
  // 获取banner
  const getBanner = async () => {
    const res = await clientFetchPageBanner({
      type: 2,
      channel: 0,
      industry1: detail.value.firstIndustryId,
      industry2: detail.value.industry1,
      areaType: detail.value.regionType
    })
    if (res?.code === ResponseCode.SUCCESS) {
      for (let i = 0; i < res?.data.length; i++) {
        const url = res?.data[i].bannerUrlList
        const link = res?.data[i].bannerLinkListPc
        banner.value.push({ url, link })
      }
    }
  }
  // 获取展会图片(展会视图)
  const getResource = async () => {
    // console.log('3367-')
    const res = await fetchExhibitionResource({
      exhibitionId: detail.value.exhibitionId
    }) // { watch: false }
    if (res?.code === ResponseCode.SUCCESS) {
      // console.log('3368-',res.data)
      resourceList.value = res?.data
    }
  }
  // 获取playauth
  const getPlayAuth = async () => {
    if (import.meta.server) return
    const { initAliplayer } = await import('~/views/fair/player')

    const el = document.getElementById('J_prismPlayer')
    if (!el && resetNum < 10) {
      await sleep(1000)
      getPlayAuth()
      resetNum = resetNum + 1
      return
    }
    isLoading.value = false
    const resourceUrl = _.get(detail, 'value.video.resourceUrl', '')
    if (!resourceUrl) return false
    let vid
    try {
      vid = JSON.parse(resourceUrl)[0]
    } catch (error) {
      if (import.meta.client && 'fundebug' in window) {
        ;(window as any).fundebug.notifyError(`${error},useFairDetail-931`)
      }
      //   console.error(error);
    }
    if (!vid) return
    if (vid.includes('.mp4') || vid.includes('.m3u8') || vid.includes('.m4v')) {
      player.value = initAliplayer('mp4', vid, '')
    } else {
      const res = await fetchVideoPlayAuth(vid)
      if (res?.code === ResponseCode.SUCCESS) {
        playauth.value = res.data
        player.value = initAliplayer('m3u8', vid, res.data)
      }
    }
  }
  const getNewPeriodical = async () => {
    const id = route.params.id
    const res = await clientFetchNewPeriodical({ id })

    if (res?.code === ResponseCode.SUCCESS && res?.data) {
      newPeriodical.value = {
        ...res?.data,
        containPhoneEmail: res?.data.containPhoneEmail?.split(',') || []
      }
    }
  }
  const fetchHotel = async () => {
    const { longitude, latitude, cityName } = detail.value.pavilionInfo || {}

    const getLocationInfo = async () => {
      if (cityName) {
        return { display: cityName, displayCode: getCodeByName(cityName) }
      } else if (longitude && latitude) {
        try {
          const locationRes: any = await fetchReverseGeocoding({ latitude, longitude })

          if (locationRes?.status === 0) {
            const { city, province } = locationRes?.result.addressComponent
            const display = !city ? province : city
            return { display, displayCode: getCodeByName(display) }
          }
        } catch (e) {
          //   console.error(e);
        }
      }
      return { display: null, displayCode: null }
    }

    const { display: _display, displayCode: _displayCode } = await getLocationInfo()

    if (!_display || !_displayCode) {
      return // Exit early if display or displayCode is null
    }

    display.value = _display
    displayCode.value = _displayCode

    const hotelListParams = {
      checkInDate: dayjs().format('YYYY-MM-DD'),
      checkOutDate: dayjs().add(3, 'days').format('YYYY-MM-DD'),
      adultNum: 1,
      cityCode: displayCode.value,
      keyWords: optionName,
      hotelStar: '4,5',
      pageNo: 1,
      pageSize: 6,
      sortCode: 0 // 0：默认 1：低价优先 2：高价优先 3：距离优先 4：好评优先
    }

    try {
      const res = await fetchHotelList(hotelListParams)

      if (res?.code === ResponseCode.SUCCESS) {
        hotelList.value = _.get(res, 'data.body.module.items', [])
      }
    } catch (error) {
      //   console.error(error);
    }
  }
  const getPercent = (val: number) => {
    return (val / 5) * 100 + '%'
  }
  const setNavIndustry = (data: string): string => {
    if (!data) {
      return ''
    }
    let str = !lang || lang == 'cn' ? '展会' : ' Exhibition'
    try {
      return data.split(',')[0] + str
    } catch (error) {
      if (import.meta.client && 'fundebug' in window) {
        ;(window as any).fundebug.notifyError(`${error},useFairDetail-1019`)
      }
      return data + str
    }
  }
  const handleOnlineService = () => {
    let serviceEl: any = document.getElementById('k_s_ol_chatWinSm_imgDiv') // ceshiidmap k_s_ol_chatWinSm

    serviceEl.click()
  }
  const handleHotTab = (e: number) => {
    innerChainActive.value = e
  }
  const handleSubsidy = () => {
    showSubsidy.value = true
  }
  const handlePoster = () => {
    showPoster.value = true
  }
  const handleContent = () => {
    window.open(`/exhibition/${detail.value.exhibitionId}.html#content`, '_blank')
  }
  const handleView = () => {
    window.open(`/exhibition/${detail.value.exhibitionId}.html#view`, '_blank')
  }
  const getAddress = () => {
    mapDialogShow.value = true
  }
  const toExhibitionDel = (id: number | string) => {
    window.open(`/exhibition/${id}.html`, '_blank')
  }
  const goToInformation = () => {
    $windowOpen(`/expoinfo/${route.params.id}.html`, '_blank')
  }
  // 下载申请招展函
  const apply = (name: string) => {
    applyTitle.value = _.cloneDeep(name)
    if (name === '展商/电子会刊查看') {
      $windowOpen(`/periodical/${route.params.id}.html`, '_blank')
    } else {
      applyVisible.value = true
    }
  }
  const handleClose = () => {
    applyVisible.value = false
  }
  const fetchSave = async () => {
    const res = await fetchApplyBooth({
      ...ruleForm.value,
      exhibitionId: +detail.value.exhibitionId,
      promotionLink: window.location.href
    })
    if (res?.code === ResponseCode.SUCCESS) {
      ruleRef.value?.resetFields()
      applyVisible.value = false
      // TODO
      await message.call(this, {
        delay: 3000,
        type: 'success',
        title: '服务咨询成功',
        msg: '专业客服将在1-2个工作日内电话与您联系。'
      })
    }
  }
  const submit = (formEl: FormInstance | null) => {
    formEl?.validate(valid => {
      if (valid) {
        fetchSave()
      } else {
        console.log('error submit!!')
      }
    })
  }
  const resetForm = (formEl: FormInstance | null) => {
    formEl?.resetFields()
    applyVisible.value = false
  }
  const handleShowMini = () => {
    dialogShow.value = true
    dialogTitle.value = t('footer.scan_openApplet')
    dialogImg.value = JuZhanMini
  }
  const handlePreview = () => {
    if (!isLogin.value) {
      return loginModal?.value.open()
    }
  }
  const closeVideo = () => {
    player.value?.dispose()
    videoVisible.value = false
  }
  const shouldLogin = () => {
    // 获取不到token为未登录, 前往登录页
    if (!isLogin.value) {
      return loginModal?.value.open()
    }
    return !!isLogin.value
  }
  // 显示购买弹窗
  const showPay = async () => {
    if (shouldLogin()) {
      const res = await fetchOrderStatus(detail.value.exhibitionId)

      if (res?.code === ResponseCode.SUCCESS) {
        // 订单状态 1-未支付 2-已支付 3-已提交 4-已完成
        if (_.get(res, 'value.data.status', null) === 2) {
          showOrderInfo(res?.data)
        } else {
          payDespositRef.value.dialogVisible = true
        }
      }
    }
  }
  // 显示填写购买信息框
  const showOrderInfo = (data: any) => {
    if (shouldLogin()) {
      orderInfoRef.value.dialogVisible = true
      orderInfoRef.value.orderData = data
    }
  }
  // 显示评价弹窗
  const showEva = () => {
    if (shouldLogin()) {
      evaluationRef.value.dialogVisible = true
    }
  }
  // 获取元素距离页面顶部的距离
  const getDisTop = (element: any) => {
    let realTop = element.offsetTop
    let parent = element.offsetParent
    while (parent !== null) {
      realTop += parent.offsetTop
      parent = parent.offsetParent
    }
    return realTop
  }
  const handleClick = () => {
    showTitle.value = activeName.value === 'first'
  }
  const setCurrent = (title: string) => {
    current.value = title
  }
  // 控制进度条不显示百分比
  const format = () => {
    return ''
  }
  const handleRemind = async () => {
    if (shouldLogin()) {
      const id = route.params.id
      if (!/\d+/.test(id as string)) {
        // TODO
        message.call(this, {
          delay: 3000,
          title: `展会Id:${id}不合法!`,
          type: 'error'
        })
        return
      }
      const res = await fetchExhibitionFollow({
        exhibitionId: id
      })
      if (res?.code === ResponseCode.SUCCESS) {
        remind.value = !remind.value
        exhibitionStore.setDetail({ ...detail.value, follow: remind.value })
        const title = !remind.value ? '取消通知成功!' : '添加通知成功!'
        // TODO
        message.call(this, {
          delay: 3000,
          title,
          type: 'success'
        })
        // this.$toast(!this.remind ? '取消通知成功!' : '添加通知成功!', 3000);
      }
    }
  }
  const focusQrcode = ref(false)
  const handleFollowFair = async () => {
    userStore.setOrigins(location.origin + route.fullPath)
    userStore.setAction(4)
    userStore.setIndustryId(detail.value.industry1)

    if (shouldLogin()) {
      const id = route.params.id
      // const res = await this.$axios.get(`/api/user/exhibition/${id}`);
      const res: any = await fetchExhibitionFollow({
        exhibitionId: id
      })
      if (res?.code === ResponseCode.SUCCESS) {
        isFocus.value = !isFocus.value
        detail.value.follow = !detail.value.follow
        focusQrcode.value = isFocus.value
        if (focusQrcode.value) {
          getQrcode()
        }
      }
    }
  }
  const qrcodeMiniUrl = ref('')
  const getQrcode = async () => {
    const res = await fetchCreateWXACode(
      {
        page: 'views/exh-info/exh-info',
        scene: `id=${detail.value.exhibitionId}`,
        checkPath: true,
        autoColor: false,
        lineColor: { r: 0, g: 0, b: 0 },
        envVersion: 'release'
      },
      { responseType: 'arrayBuffer' }
    )
    const blob = new Blob([res as any], { type: 'image/png' })
    const blobUrl = URL.createObjectURL(blob)
    qrcodeMiniUrl.value = blobUrl
  }
  const handleNoTicket = () => {
    ElMessage.warning('门票已售罄!')
  }
  // 阅读会刊
  const readPeriodical = () => {
    // https://www.jufair.com/periodical/1647.html
    if (lang === 'cn') {
      $windowOpen(`/periodical/${route.params.id}.html`, '_blank')
    } else {
      $windowOpen(`https://www.jufair.com/periodical/${route.params.id}.html`, '_blank')
    }
    // 埋点
    window.trace?.upload({
      module: TraceCode.MO_FAIR_PERIODICAL,
      bizId: route.params.id as string,
      callbackCode: TraceCode.CC_APPLY_PERIODICAL
    })
  }
  const goToVisa = (areaId: any) => {
    window.open(`/visa-0-${areaId}-0-0-1`, '_blank')
  }
  // 门票预订
  const handleToTicket = async () => {
    if (detail.value.thirdUrl) {
      if (!tokenCookie.value) {
        userStore.setOrigins(location.origin + route.fullPath)
        userStore.setAction(2)
        userStore.setIndustryId(detail.value.industry1)

        loginModal?.value.open()
      } else {
        window.trace?.upload({
          module: TraceCode.MO_FAIR_TICKET,
          bizId: route.params.id as string,
          callbackCode: TraceCode.CC_TICKET_OUT
        })
        window.open(detail.value.thirdUrl, '_blank')
      }
    } else {
      window.trace?.upload({
        module: TraceCode.MO_FAIR_TICKET,
        bizId: route.params.id as string,
        callbackCode: TraceCode.CC_TICKET_IN
      })
      $windowOpen(`/ticket/${detail.value.exhibitionId}.html`, '_blank')
    }
  }
  // 申请展位
  const handleApply = () => {
    console.log(lang)
    if (lang === 'en') {
      // 如果是英文直接跳转生产环境的地址
      $windowOpen(`https://www.jufair.com/exhibition/apply/${route.params.id}.html`, '_blank')
    } else {
      $windowOpen(`/exhibition/apply/${route.params.id}.html`, '_blank')
    }
    // 1.展位图
    // 埋点
    window.trace?.upload({
      module: TraceCode.MO_FAIR_BOOTH,
      bizId: route.params.id as string,
      callbackCode: TraceCode.CC_APPLY_BOOTH
    })
  }
  const handleToTRip = () => {
    window.open(`/exhibition/trip/${route.params.id}.html`, '_blank')
  }
  // 查看更多
  const handleShowrticle = () => {
    showMore.value = !showMore.value
    if (!showMore.value) {
      setTimeout(() => {
        serverStepRef.value?.scrollIntoView(true)
      }, 300)
    }
  }
  const toLogin = () => {
    loginModal?.value.open()

    sessionStorage.setItem('ticketForm', JSON.stringify(ruleForm.value))
    // sessionStorage.setItem(
    //   'invoiceRuleForm',
    //   JSON.stringify(invoiceRuleForm.value),
    // );
  }
  const toExposer = () => {
    $windowOpen(`/community/${route.params.id}.html`, '_blank')
  }
  const toCommunity = () => {
    $windowOpen(`/community/${route.params.id}.html`, '_blank')
  }
  const handleFollowChange = async (val: number) => {
    const res = await fetchExhibitionFollowedUsers({
      exhibitionId: detail.value.exhibitionId,
      pageNum: val,
      pageSize: 12
    })

    if (res?.code === ResponseCode.SUCCESS) {
      follow.value.data = res.data.records
      follow.value.total = res.data.total
    }
  }

  watch(stateIsLogin, v => {
    // ...
  })
  // 中文域名打开英文展会,则跳转到英文域名; 英文域名打开中文展会,则跳转到中文域名;
  const checkFairLanguage = () => {
    let hostNameCn: any = runtime.public.config.HOST_NAME
    let hostNameEn: any = runtime.public.config.HOST_NAME_EN
    let hostName: any = window.location.origin // 当前域名
    const routeParams = route.params
    const routeQuery = route.query
    // console.log('3280',hostName, hostNameEn)
    let newHost: any = '' // 要跳转的地址
    let t1: any =
      hostName.includes('en.jufair.com') &&
      (!detail.value.hasOwnProperty('locale') ||
        !detail.value.locale ||
        detail.value.locale == 'CN') // 英文域名 && 展会语言是CN
    let t2: any =
      hostName.includes('www.jufair.com') &&
      detail.value.hasOwnProperty('locale') &&
      detail.value.locale == 'EN'
    let t3: any =
      hostName.includes('pre-pc.jufair.com') &&
      detail.value.hasOwnProperty('locale') &&
      detail.value.locale == 'EN'
    let t4: any =
      hostName.includes('192.168.1.138') &&
      detail.value.hasOwnProperty('locale') &&
      detail.value.locale == 'EN'

    // 没有locale || locale 为空则认为是中文展会
    if (
      hostName.includes('en.jufair.com') &&
      (!detail.value.locale || !detail.value.hasOwnProperty('locale'))
    ) {
      window.location.replace(`https://www.jufair.com/exhibition/${routeParams.id}.html`)
    }

    if ((t1 || t2) && !routeQuery.hasOwnProperty('debug')) {
      if (t1) newHost = hostNameCn
      if (t2) newHost = hostNameEn
      if (t3) newHost = hostNameEn
      if (t4) newHost = hostNameEn
      let newUrl: any = `${newHost}/exhibition/${routeParams.id}.html`
      window.location.replace(newUrl) // 重定向到正确的域名
    }
  }

  const _querySearchAsync = _.debounce(async function (str: string, cb: (val: any[]) => void) {
    let data: any[]
    if (str && str.trim()) {
      const res = await fetchCompanyByKeyword(
        { value: str.trim() },
        {
          headers: {
            'Content-Type': 'text/plain'
          }
        }
      )
      data = res?.data.map((r: string) => ({ value: r }))
    } else {
      data = []
    }
    cb(data)
  }, 300)

  const querySearchAsync = (str: string, cb: (val: any[]) => void) => {
    _querySearchAsync(str, cb)
  }

  const getBusiness = (tag: any) => {
    if (tag === 'visa') {
      // router.push(`/visa-0-0-0-0-1/`)

      window.open(`https://visa.jufair.com/visa-0-0-0-0-1/`)
    } else {
      // TODO
      // window.open(`${}`, '_self');
    }
  }

  // 客服SDK初始化
  const init = () => {
    ;(window as any).ysf('onready', () => {
      isSdkReady.value = true
    })
  }

  // 点击打开聊天窗
  const openkefu = (chat: string) => {
    if (chat) {
      if (isSdkReady.value) {
        ;(window as any).ysf('open')
      }
    } else {
      window.open(chat)
    }
  }

  const handleToApplyByType = (type: string) => {
    const id = route.params.id
    router.push(`/exhibition/apply/${id}.html?type=${type}`)
  }

  const openVideo = () => {
    if (!isLogin.value) {
      return loginModal?.value.open()
    }
    videoVisible.value = true
    nextTick(() => {
      getPlayAuth()
    })
  }

  const handleUnlock = () => {
    if (shouldLogin()) {
      window.open(`/periodical/${id}.html`, '_blank')
    }
  }

  const handleViewExhibitor = (item: any, periodicalId: string) => {
    if (shouldLogin()) {
      window.open(
        `/company/${item.companyId}.html?periodicalId=${periodicalId}&fairId=${id}`,
        '_blank'
      )
    }
  }

  const $get = _.get<any, string>

  exhibitionStore.setDetail(detail.value)
  exhibitionStore.setPeriodicalList(periodicalList.value)
  exhibitionStore.setExhibitorData(exhibitorData.value)
  const hasOrder = ref(false)
  const fetchHasOrder = async () => {
    if (!isLogin.value) {
      return
    }
    const res = await exhibitorCheckUser({
      periodicalId: periodicalList.value.id
    })
    if (res?.code === ResponseCode.SUCCESS) {
      hasOrder.value = res.data
    }
  }
  fetchHasOrder()
  const getCompanyName = (str: string) => {
    return str ? str.slice(0, 2) : ''
  }
  const toCompanyDetail = (id: string) => {
    if (!isLogin.value) {
      return loginModal?.value.open()
    }
    window.open(
      `/company/${id}.html?periodicalId=${periodicalList.value.id}&fairId=${route.params.id}`
    )
  }

  const toExpouser = () => {
    router.push(`/expouser/${_.get(globalStore, 'user.id', '')}.html`)
  }

  return {
    detail,
    route,
    booth,
    lang,
    sameFair,
    isLogin,
    tips,
    showMessage,
    messageList,
    datePosition,
    headimg,
    rateValue,
    rateData,
    showTitle,
    routeHash,
    current,
    showView,
    resourceList,
    photos,
    activeName,
    industryList,
    newPeriodical,
    hasPhoneOrEmail,
    industryFair,
    sameSwiperOption,
    areaExhList,
    downloadList,
    boothServiceList,
    ticketServiceList,
    banner,
    pavilionPicture,
    attribution,
    center,
    follow,
    remind,
    tag,
    globalStore,
    logoFair,
    industry,
    fairNews,
    news,
    newNews,
    newFair,
    innerChainActive,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    videoVisible,
    isLoading,
    applyTitle,
    applyVisible,
    ruleForm,
    rules,
    ruleRef,
    dialogTitle,
    dialogShow,
    dialogImg,
    reptileShow,
    messageTitle,
    mapDialogShow,
    showPoster,
    showSubsidy,
    exhibitorData,
    periodicalList,
    shouldLogin,
    newDateFormat,
    getAddress,
    formatNumber,
    handleApply,
    handleSubsidy,
    toExposer,
    industryFilter,
    setNavIndustry,
    getPercent,
    handleToTicket,
    toExhibitionDel,
    setCurrent,
    handleShowMini,
    getBusiness,
    handleView,
    handlePoster,
    handleContent,
    openVideo,
    handlePreview,
    handleClick,
    readPeriodical,
    apply,
    handleOnlineService,
    toCommunity,
    handleRemind,
    showEva,
    format,
    goToInformation,
    handleHotTab,
    closeVideo,
    handleClose,
    querySearchAsync,
    resetForm,
    submit,
    logo,
    $t,
    $get,
    handleFollowFair,
    handleUnlock,
    handleViewExhibitor,
    hasOrder,
    getCompanyName,
    toCompanyDetail,
    isFocus,
    qrcodeMiniUrl,
    focusQrcode,
    sessionsFair,
    serviceListAll,
    toExpouser
  }
}
